export default __webpack_public_path__ + "7343b2816e95b2b84526fb359865627a.svg";